import moment from 'moment';

const convertValueEnterToHours = (chosenTime, newValue = false) => {
  const convertToString = newValue ? moment(chosenTime).format('HH:mm') : chosenTime;
  const timeParts = convertToString.split(':');
  return parseFloat(Number(timeParts[0]) + Number(timeParts[1]) / 60);
};

export default convertValueEnterToHours;
